import React from "react";
import * as RD from "reports/ReportDef";

interface CitationDisplayProps {
    citations: RD.Citations;
    citationIndex?: number;
    className?: string;
}

/**
 * CitationDisplay component renders a citation reference
 * Uses small font size, italicized, and light gray text
 */
export const CitationDisplay: React.FC<CitationDisplayProps> = ({ citations, citationIndex, className = "" }) => {
    if (citationIndex === undefined || citationIndex === null || !citations || !citations[citationIndex]) {
        return null;
    }

    const citation = citations[citationIndex];

    return (
        <span className={`text-xs italic text-gray-400 ${className}`}>
            {citation.name}
        </span>
    );
};

export default CitationDisplay;
